import { call, put, select, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import SideBarTypes from './constants'

import * as sidebarActions from './actions'

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { 
      throw error;
    })
}

function requestApi  (formData) {
  const request = axiosApi().post(
    SideBarTypes.REQUEST_API, 
    formData
  )
  return handleRequest(request);
}

function* requestFlow ({payload, callback}) {
  try {
    // call to our headersRequestApi function with the client
    const results = yield call(requestApi, payload)
    // dispatch the action with our widgets!
    yield put(sidebarActions.SidebarRequestSuccess(results))
    if (typeof callback === 'function') {
      yield call(callback, results)
    }
  } catch (error) {
    console.log(error)
    yield put(sidebarActions.SidebarRequestError(error))
  }
}

function* headersWatcher () {
  // each of the below RECEIVES the action from the .. action
  //const { client: { history } } = yield take(HEADER_REQUESTING)
  yield takeLatest(SideBarTypes.REQUESTING, requestFlow)
}

export default headersWatcher



// WEBPACK FOOTER //
// ./src/components/Sidebar/sagas.js